import '@angular/compiler';
import { PageChecklistRespondComponent } from './page.checklist.respond/page.checklist.respond.component';
import { ComponentProjectFacilitiesComponent } from './component.project.facilities/component.project.facilities.component';
import { PageUserRolesComponent } from './page.user.roles/page.user.roles.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentAuthRegisterComponent } from './component.auth.register/component.auth.register.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentProjectDrawingsComponent } from './component.project.drawings/component.project.drawings.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { ComponentProjectDocumentsComponent } from './component.project.documents/component.project.documents.component';
import { PageMainComponent } from './page.main/page.main.component';
import { ComponentProjectFacilityAddComponent } from './component.project.facility.add/component.project.facility.add.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentAuthForgotComponent } from './component.auth.forgot/component.auth.forgot.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PageProjectDetailComponent } from './page.project.detail/page.project.detail.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageChecklistEditComponent } from './page.checklist.edit/page.checklist.edit.component';
import { ComponentMainOverviewComponent } from './component.main.overview/component.main.overview.component';
import { ComponentAuthLoginComponent } from './component.auth.login/component.auth.login.component';
import { PageProjectListComponent } from './page.project.list/page.project.list.component';
import { PageChecklistListComponent } from './page.checklist.list/page.checklist.list.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { ComponentProjectDocumentAddComponent } from './component.project.document.add/component.project.document.add.component';
import { ComponentMainProjectsComponent } from './component.main.projects/component.main.projects.component';
import { ComponentMainProjectAddComponent } from './component.main.project.add/component.main.project.add.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageChecklistResultComponent } from './page.checklist.result/page.checklist.result.component';
import { ComponentProjectDrawingAddComponent } from './component.project.drawing.add/component.project.drawing.add.component';

const INDEX_PAGE = "login";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutNavbarComponent,
        "children": [
            {
                "path": "checklist/respond/:responseId",
                component: PageChecklistRespondComponent,
                "app_id": "page.checklist.respond"
            },
            {
                "path": "user/roles",
                component: PageUserRolesComponent,
                "app_id": "page.user.roles"
            },
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "project/detail/:id",
                component: PageProjectDetailComponent,
                "app_id": "page.project.detail"
            },
            {
                "path": "checklist/edit/:id",
                component: PageChecklistEditComponent,
                "app_id": "page.checklist.edit"
            },
            {
                "path": "project/list",
                component: PageProjectListComponent,
                "app_id": "page.project.list"
            },
            {
                "path": "checklist/list",
                component: PageChecklistListComponent,
                "app_id": "page.checklist.list"
            },
            {
                "path": "checklist/result/:responseId",
                component: PageChecklistResultComponent,
                "app_id": "page.checklist.result"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }